import {Injectable} from "@angular/core";
import {HttpBaseService} from "@tva/ng-migration/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Pathway, PathwayDetails, PathwaySchoolCourse} from "../models";
import {schoolwork12} from "@tva/ng-migration/common/util";

@Injectable({
    providedIn: "root",
})
export class CreDetailsService extends HttpBaseService{

    constructor(client: HttpClient) {
        super(client);
    }

    public getCtePathways(school): Observable<Pathway[]> {
        return this.get(schoolwork12.app.creManagement.endpoints.ctePathways(school));
    }

    public getCtePathwayCourses(pathway): Observable<PathwayDetails> {
        return this.get(schoolwork12.app.creManagement.endpoints.ctePathwayDetail(pathway));
    }

    public  getCteCourses(school): Observable<PathwaySchoolCourse[]> {
        return this.get(schoolwork12.app.creManagement.endpoints.cteCourseList(school));
    }

    public  saveCtePathways(data: any): Observable<any> {
        return this.put(schoolwork12.app.creManagement.endpoints.ctePathwaySave, data);
    }
}
